export const DMP = {
  mapId: 2,
  DimensionID: 1,
  mapApplicabilityId: 4,
  mapStructure: "EEE",
  discardMapRule: "PPP",
  addRule: "LLU",
  weightRule: "AAU",
  targetRule: "EARM",
  achievementRule: "",
  ratingScaleId: "1678793170575",
  secondGroups: [
    {
      TransactionID: 1,
      DimensionID: 1,
      GroupLevel: 2,
      GroupName: "Financial",
      GroupShortName: "fintech",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
    {
      TransactionID: 2,
      DimensionID: 1,
      GroupLevel: 2,
      GroupName: "Marketing",
      GroupShortName: "fishing",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
  ],
  firstGroups: [
    {
      TransactionID: 3,
      DimensionID: 1,
      GroupLevel: 1,
      SecondGroupID: 1,
      GroupName: "Product Development",
      GroupShortName: "surfing",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
    {
      TransactionID: 4,
      DimensionID: 1,
      GroupLevel: 1,
      SecondGroupID: 1,
      GroupName: "Frontend Building",
      GroupShortName: "UI/UX",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
    {
      TransactionID: 5,
      DimensionID: 1,
      GroupLevel: 1,
      SecondGroupID: 2,
      GroupName: "Sales",
      GroupShortName: "buying",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
    {
      TransactionID: 6,
      DimensionID: 1,
      GroupLevel: 1,
      SecondGroupID: 0,
      GroupName: "Designing",
      GroupShortName: "figmas",
      GroupDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    },
  ],
  parameters: [
    {
      TransactionID: 1,
      DimensionID: 1,
      ParameterGroupID: 3,
      ParameterName: "KRA",
      ParameterShortName: "kra",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Bytes",
      ParameterTargetDataType: "NI",
      AchievementDataType: "NI",
      ParameterTargets: [
        {
          ScaleOptionID: "8b200f67-b847-4a4e-997f-b718de09e1e7",
          TargetValue: "",
          MinimumTargetValue: "0",
          MaximumTargetValue: "20",
        },
        {
          ScaleOptionID: "81c44f89-4438-4c4d-92fc-8ab61887321d",
          TargetValue: "",
          MinimumTargetValue: "21",
          MaximumTargetValue: "40",
        },
        {
          ScaleOptionID: "7c2e6831-bdb3-4a46-94ae-c8e38aecf02d",
          TargetValue: "",
          MinimumTargetValue: "41",
          MaximumTargetValue: "60",
        },
        {
          ScaleOptionID: "6cb2be64-23c3-44db-8f48-0a9697cc9200",
          TargetValue: "",
          MinimumTargetValue: "61",
          MaximumTargetValue: "100",
        },
      ],
    },
    {
      TransactionID: 2,
      DimensionID: 1,
      ParameterGroupID: 3,
      ParameterName: "KPI",
      ParameterShortName: "kpi",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Short",
      ParameterTargetDataType: "NI",
      ParameterTargets: [
        {
          ScaleOptionID: "8b200f67-b847-4a4e-997f-b718de09e1e7",
          TargetValue: "",
          MinimumTargetValue: "0",
          MaximumTargetValue: "20",
        },
        {
          ScaleOptionID: "81c44f89-4438-4c4d-92fc-8ab61887321d",
          TargetValue: "",
          MinimumTargetValue: "21",
          MaximumTargetValue: "40",
        },
        {
          ScaleOptionID: "7c2e6831-bdb3-4a46-94ae-c8e38aecf02d",
          TargetValue: "",
          MinimumTargetValue: "41",
          MaximumTargetValue: "60",
        },
        {
          ScaleOptionID: "6cb2be64-23c3-44db-8f48-0a9697cc9200",
          TargetValue: "",
          MinimumTargetValue: "61",
          MaximumTargetValue: "100",
        },
      ],
    },
    {
      TransactionID: 3,
      DimensionID: 1,
      ParameterGroupID: 3,
      ParameterName: "Values",
      ParameterShortName: "values",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
    {
      TransactionID: 4,
      DimensionID: 1,
      ParameterGroupID: 4,
      ParameterName: "Potential",
      ParameterShortName: "potential",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Bytes",
    },
    {
      TransactionID: 5,
      DimensionID: 1,
      ParameterGroupID: 4,
      ParameterName: "Capability",
      ParameterShortName: "power",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Short",
    },
    {
      TransactionID: 6,
      DimensionID: 1,
      ParameterGroupID: 4,
      ParameterName: "Skills",
      ParameterShortName: "tech stacks",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
    {
      TransactionID: 7,
      DimensionID: 1,
      ParameterGroupID: 5,
      ParameterName: "Behavior",
      ParameterShortName: "important",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
    {
      TransactionID: 8,
      DimensionID: 1,
      ParameterGroupID: 5,
      ParameterName: "Projects",
      ParameterShortName: "count",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Bytes",
    },
    {
      TransactionID: 9,
      DimensionID: 1,
      ParameterGroupID: 5,
      ParameterName: "Honors",
      ParameterShortName: "enough papers",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Short",
    },
    {
      TransactionID: 10,
      DimensionID: 1,
      ParameterGroupID: 5,
      ParameterName: "License",
      ParameterShortName: "cars",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
    {
      TransactionID: 11,
      DimensionID: 1,
      ParameterGroupID: 6,
      ParameterName: "Speed",
      ParameterShortName: "counts",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Bytes",
    },
    {
      TransactionID: 12,
      DimensionID: 1,
      ParameterGroupID: 6,
      ParameterName: "Mileage",
      ParameterShortName: "required",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Short",
    },
    {
      TransactionID: 13,
      DimensionID: 1,
      ParameterGroupID: 6,
      ParameterName: "Shades",
      ParameterShortName: "not required",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
    {
      TransactionID: 14,
      DimensionID: 1,
      ParameterGroupID: 0,
      ParameterName: "Weight",
      ParameterShortName: "important",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Short",
    },
    {
      TransactionID: 15,
      DimensionID: 1,
      ParameterGroupID: 0,
      ParameterName: "Height",
      ParameterShortName: "ok",
      ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
      ParameterUOM: "Int",
    },
  ],
  acheivementDataType: "",
};
